import React from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';

import Label from '../../../../components/Label';
import Dropdown from '../../../../components/Dropdown';
import messages from './messages';

import '../styles.css';

const CampusSurroundings = ({ onChange, initialValue, formatMessage }) => {
  const id = uniqueId('campus-surroundings');
  return (
    <div styleName="field">
      <Label styleName="menu-field-label" as="label" htmlFor={id}>
        {initialValue.label}
      </Label>
      <Dropdown
        placeholder={formatMessage(messages.campusSurroundings)}
        fluid
        selection
        id={id}
        data-cy="premium-Hem-Campus-Surroundings-Dropdown"
        options={initialValue.options}
        value={initialValue.value}
        onChange={(e, { value }) => {
          onChange(e, { value });
        }}
      />
    </div>
  );
};
CampusSurroundings.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
  formatMessage: PropTypes.func,
};

export default CampusSurroundings;
